import { render, staticRenderFns } from "./LargeSwitch.vue?vue&type=template&id=26795d46"
import script from "./LargeSwitch.vue?vue&type=script&lang=js"
export * from "./LargeSwitch.vue?vue&type=script&lang=js"
import style0 from "./LargeSwitch.vue?vue&type=style&index=0&id=26795d46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports